import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import de from './locales/de.json';
import en from './locales/en.json';
import tr from './locales/tr.json';
import ar from './locales/ar.json';
import pl from './locales/pl.json';
import pt from './locales/pt.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import uk from './locales/uk.json';
import es from './locales/es.json';

const resources = {
  de: { translation: de },
  en: { translation: en },
  tr: { translation: tr },
  ar: { translation: ar },
  pl: { translation: pl },
  pt: { translation: pt },
  fr: { translation: fr },
  it: { translation: it },
  uk: { translation: uk },
  es: { translation: es }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    debug: false,
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;
